import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import MainContainer from "pages/_components/MainContainer";
import * as i18n from "util/i18n";
import Button from "pages/_components/Button";
import Action from "pages/_components/Action";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import { ResponsiveHeader, DesktopButtons, MobileButtons } from "pages/_components/header";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { transactionStatus } from "pages/transactions/constants";
import { actions as debinActions } from "reducers/debin";
import { useTransaction } from "hooks/useTransactions";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import { isIOS } from "react-device-detect";
import PayDebinSummaryBody from "./components/Summary";

const EmitDebinTransactionPage = ({ isDesktop }) => {
    const formatTransactionDebin = (data, idTransaction) => {
        const formData = {
            sellerName: data?.sellerName || "-",
            sellerCuit: data?.sellerCuit || "-",
            amountSumary: data?.amountSumary,
            solicitDate: data?.solicitDate || "-",
            dueDate: data?.dueDate || "-",
            debinId: data?.debinId || "-",
            sellerCbu: data?.sellerCbu || "-",
            alias: data?.alias || "-",
            bank: data?.bank || "-",
            concept: data?.concept || "-",
            description: data?.description || "-",
            reference: data?.reference || "-",
            curencySeller: data?.curencySeller || "-",
            debitAccountMask: data?.debitAccountMask || "-",
            currency: data?.currency,
            idDebin: data?.idDebin,
            idAccount: data?.idAccount,
            idVoucher: data?.idVoucher,
            amount: data?.amount,
            debitAccount: data?.debitAccount,
            sellerDetail: data?.sellerDetail,
            debinDetail: data?.debinDetail,
        };

        return { ...formData, idTransaction };
    };

    const { isLoading, transaction, dispatch, handleSignTransaction, showSignButton, push, id, status: { isBackoffice } } = useTransaction(
        "/debinPayments/action/received",
        debinActions.setDetail,
        debinActions.cleanDebinTicket,
        formatTransactionDebin,
    );
    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "debin.pay.debin",
        id,
        "pay.debin.trasaction",
    );
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const isFinished = transactionStatus.FINISHED === transaction.idTransactionStatus;

    const handleDownload = async () => {
        await setShowMoreData(true);
        return handlePrint();
    };

    return (
        <>
            <Notification scopeToShow="pay.debin.trasaction" />
             {!isBackoffice && (
                <ResponsiveHeader ticket metaTitle="debin.pay.debin" id="debin.pay.debin" />
             )}
            <MainContainer showLoader={isLoading}>
                <div className="container transaction-ticket" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title="debin.pay.debin" />
                            <div className="ticket account-pending">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />

                                    <PayDebinSummaryBody
                                        isTicket
                                        isDesktop={isDesktop}
                                        setShowMoreData={setShowMoreData}
                                        showMoreData={showMoreData}
                                    />
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                     {!isBackoffice && (
                    <Row className="form-actions no-print">
                                <Col
                                xs={12}
                                md={4}
                                mdOffset={2}>
                                <Button
                                    onClick={() => dispatch(push("/desktop"))}
                                    label="forms.transaction.ticket.actions.backToHome"
                                    className={`btn${
                                        isFinished  ? " btn-outline" : " btn-primary"
                                    }`}
                                />
                                </Col>
                                <Col xs={12} md={4}>
                                    <Button
                                        onClick={handleDownload}
                                        label="global.download"
                                        className="btn btn-primary"
                                        image="images/download.svg"
                                    />
                                </Col>
                                {!isDesktop && (
                                    <Col xs={12} md={4}>
                                        <Button
                                            className="btn btn-outline"
                                            image="images/figma/icon/share.svg"
                                            label="global.share"
                                            onClick={() => {
                                                handleShareMobile();
                                            }}
                                        />
                                    </Col>
                                )}
                        {showSignButton && (
                            <Col xs={12} md={4}>
                                <Button
                                    onClick={handleSignTransaction}
                                    label="forms.signTransaction.link"
                                    className="btn btn-primary"
                                />
                            </Col>
                        )}
                    </Row>
                     )}
                </div>
            </MainContainer>
        </>
    );
};

EmitDebinTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default EmitDebinTransactionPage;
